import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { FundsField } from '@/components/forms/RunRiskCalibrationForm/fields/FundsField'
import { InstanceTagField } from '@/components/forms/RunRiskCalibrationForm/fields/InstanceTagField'
import { ValueDateField } from '@/components/forms/RunRiskCalibrationForm/fields/ValueDateField'

export interface DefaultRiskFieldsProps {}

export const DefaultRiskFields: React.FC<DefaultRiskFieldsProps> = ({}) => {
  return (
    <div className={'space-y-4'}>
      <FormFieldRow>
        <ValueDateField />
        <InstanceTagField />
      </FormFieldRow>
      <FundsField />
    </div>
  )
}
